import { LoyaltyTier, LoyaltyTierProvider } from '@models/LoyaltyTier'
import { useAppDispatch } from '@store/hooks'
import { getLoyaltyTiers } from '@store/LoyaltyTierReducer'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { Button, Divider, Flex, Modal, Space, Tag, Typography } from 'antd'
import Avatar from 'antd/es/avatar'
import { FC, useState } from 'react'
import { HelpButton } from '../help/HelpButton'
import { LoyaltyTierTagList } from './TagList'

const { Title, Text } = Typography

interface Props {
  loyaltyTier: LoyaltyTier
  loyaltyTierProvider: LoyaltyTierProvider
}

const ProviderCard: FC<Props> = ({ loyaltyTier, loyaltyTierProvider }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
  const dispatch = useAppDispatch()

  return (
    <Flex vertical className="w-full">
      <Flex justify="space-between" align="center">
        <Space orientation="vertical">
          <Space className="w-full space-between">
            <Space>
              <Avatar size={20} shape="square" />
              <Title
                className="m-0"
                level={5}
                style={{ textTransform: 'capitalize' }}
              >
                {loyaltyTierProvider.provider}
              </Title>
            </Space>
          </Space>
          <Text style={{ fontWeight: 'bold' }}>
            {loyaltyTierProvider.description}
          </Text>
          {loyaltyTier.title != 'Default' && (
            <LoyaltyTierTagList
              color={loyaltyTier.color}
              tags={loyaltyTierProvider.tags}
              loyaltyTierProviderId={loyaltyTierProvider.id}
              onTagsChange={() => dispatch(getLoyaltyTiers(initialQuery))}
            />
          )}
        </Space>

        <Modal
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onOk={() => setIsModalOpen(false)}
        >
          <Space
            style={{
              display: 'flex',
              flexDirection: 'column',
              margin: '20px',
              gap: '20px',
            }}
          >
            <Text>
              In order to limit access to certain time slot you may use this
              reservation tag on your access rule
            </Text>
            <HelpButton articleId="10" />
            <Text>Reservation tag category</Text>
            <Tag>
              <Text copyable style={{ textAlign: 'center' }}>
                {loyaltyTierProvider.reservationTagCategory}
              </Text>
            </Tag>
            <Text>Reservation tag name</Text>
            <Tag>
              <Text copyable style={{ textAlign: 'center' }}>
                {loyaltyTierProvider.reservationTag}
              </Text>
            </Tag>
          </Space>
        </Modal>
        <Button
          variant="outlined"
          color={loyaltyTier.color}
          onClick={() => setIsModalOpen(true)}
        >
          Limit Access to this Tag
        </Button>
      </Flex>

      <Divider />
      <Space orientation="vertical" className="w-full">
        <Text style={{ fontWeight: 'bold' }}>
          These tags will be automatically added to the customer's PMS profile
          when they are assigned to this loyalty tier, and removed if the tier
          is detached.
        </Text>
        <Space>
          {loyaltyTierProvider.PMSClientTags.map((tag) => (
            <Tag key={tag.id}>
              {tag.category}:{tag.name}
            </Tag>
          ))}
        </Space>
      </Space>
    </Flex>
  )
}

type ProviderCardType = { ProviderCard: typeof ProviderCard }

export { ProviderCard, type ProviderCardType }
